import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationType } from './notification.model';

@Component({
  selector: 'app-notification',
  imports: [CommonModule],
  templateUrl: './notification.html',
  styleUrl: './notification.scss',
  standalone: true
})
export class Notification {
  message = input<string>('');
  type = input<NotificationType>('success');

  getBackgroundColor(): string {
    switch (this.type()) {
      case 'success':
        return '#10B981';
      case 'error':
        return '#EF4444';
      case 'info':
        return '#3B82F6';
      default:
        return '#10B981';
    }
  }

  getIcon(): string {
    switch (this.type()) {
      case 'success':
        return 'M20 6L9 17L4 12';
      case 'error':
        return 'M18 6L6 18M6 6L18 18';
      case 'info':
        return 'M12 16V12M12 8H12.01';
      default:
        return 'M20 6L9 17L4 12';
    }
  }
}
